export default "https://cdn-static.gokick.com/assets/34a72110398b299a93da730cfac0263ae4687154/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";